import { useEventCallback } from '@cian/react-utils';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ContactsModal } from '../../components/ContactsModal';
import { ShowContactsButton } from '../../components/ShowContactsButton';
import { selectBuilderInfo } from '../../selectors/builder';
import { trackShowPhoneClick } from '../../utils/tracking';

export const ShowContactsContainer = () => {
  const { id, phone, logo, name } = useSelector(selectBuilderInfo);

  const [contactsVisible, showContacts] = React.useState(false);

  const openModal = useEventCallback(() => {
    showContacts(true);
    trackShowPhoneClick(id);
  });

  const closeModal = useEventCallback(() => {
    showContacts(false);
  });

  if (!phone) {
    return null;
  }

  return (
    <>
      <ShowContactsButton onClick={openModal} />
      <ModalWindow size="XS" open={contactsVisible} onClose={closeModal}>
        <ContactsModal phone={phone} logo={logo} name={name} />
      </ModalWindow>
    </>
  );
};
